import MarketingShell, { LegalSection } from "@/components/MarketingShell";

export default function About() {
  return (
    <MarketingShell eyebrow="/ About" title="We make businesses findable in the AI era.">
      <p className="text-lg text-foreground">
        Search has changed. People no longer scan ten blue links — they ask ChatGPT, Gemini, Claude,
        Perplexity and Google&apos;s AI Overviews a question and trust a single composed answer.
        AI Visibility OS exists to make sure your business is the answer.
      </p>

      <LegalSection heading="What we do">
        <p>
          AI Visibility OS is an operating system for Answer Engine Optimization (AEO) and
          Generative Engine Optimization (GEO). We crawl your website, measure how understandable
          and recommendable it is to AI systems, and translate the technical findings into plain-language
          actions a business owner can actually take.
        </p>
      </LegalSection>

      <LegalSection heading="Hybrid intelligence">
        <p>
          Our AI Visibility Score is deterministic — calculated by a transparent, rule-based engine across
          nine weighted categories, so it never fluctuates randomly. We use AI only where it shines:
          explaining results, generating fixes and shaping content strategy. You get the reliability of
          a real audit with the clarity of a consultant.
        </p>
      </LegalSection>

      <LegalSection heading="Who it&apos;s for">
        <p>
          Founders, small business owners and marketing teams who want to be visible in AI search without
          hiring an SEO agency. If you can paste a snippet into your website builder, you can act on our
          recommendations.
        </p>
      </LegalSection>

      <LegalSection heading="Contact">
        <p>
          Questions, feedback or partnerships? Reach us at
          {" "}<a href="mailto:hello@aivisibilityos.com" className="text-intl underline underline-offset-4">hello@aivisibilityos.com</a>.
        </p>
      </LegalSection>
    </MarketingShell>
  );
}
